// extracted by mini-css-extract-plugin
export default {"main":"hz-components-hz-layout-content-tabs-index-main"};